var module = angular.module('octopusApp.environments');

module.controller('MachinePolicyIndexController', function($scope, $location, busy, octopusRepository, octopusClient) {
  var isLoading = $scope.isLoading = busy.create();

  isLoading.promise(octopusRepository.MachinePolicies.all().then(function(machinePolicies){
      $scope.machinePolicies = machinePolicies;
  }));
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machinepolicies/controllers/machine_policy_index_controller.js
// module id = 435
// module chunks = 1